export const validateBotSettings = ({
  strategy,
  settings,
  selectedSetting,
  minimumOrder,
  baseCurrency = "USDT",
  isEdit = false,
  botDetail = null, // ADD: original bot settings
  additionalCapital = 0, // ADD: the new trade size user typed in edit mode
}) => {
  const s = settings || {};
  const formattedMinimum = Number(minimumOrder) || 0;
  const errors = {};

  // --- GRID STRATEGY ---
  if (strategy === "grid") {
    if(!isEdit){
      if (!s.amount || s.amount < formattedMinimum){
        errors.amount = `Minimum capital is ${formattedMinimum} ${baseCurrency}.`;
      }
      if (!s.trade_size || s.trade_size < formattedMinimum)
        errors.trade_size = `Minimum trade size is ${formattedMinimum} ${baseCurrency}.`;
      if (s.trade_size > 0 && s.amount > 0) {
        const maxGrids = Math.floor(s.amount / s.trade_size);
        if (selectedSetting !== "system" && !isEdit) {
          if (Number(s.number_of_grids) > maxGrids)
            errors.number_of_grids = `Max steps is ${maxGrids} for the selected capital.`;
          else if (Number(s.number_of_grids) < 1)
            errors.number_of_grids = "Number of steps must be at least 1.";
        }
      }
      if (s.amount < s.trade_size){
        errors.amount = "Capital must be greater than trade size.";
      }
    }



  
    // ADD: Edit mode — validate total trade size vs total capital
    if (isEdit && botDetail) {
      const originalAmount = Number(botDetail?.setting?.amount) || 0;
      const originalTradeSize = Number(botDetail?.setting?.trade_size) || 0;
      const originalGrids = Number(botDetail?.setting?.number_of_grids) || 0;

      const totalCapital = originalAmount + additionalCapital;
      const newTradeSize = Number(s.trade_size);
      const newNumberOfGrids = Math.floor(totalCapital / newTradeSize);

      if (newTradeSize < originalTradeSize) {
        errors.trade_size = `Trade size cannot be lower than the original trade size (${originalTradeSize} ${baseCurrency}).`;
      }

      if (newTradeSize > totalCapital) {
        errors.amount = `Trade size (${newTradeSize} ${baseCurrency}) exceeds total capital (${totalCapital} ${baseCurrency}). Please add more capital to proceed.`;
      }

      if (newNumberOfGrids < originalGrids) {
        errors.amount = `Current settings would reduce grid steps from ${originalGrids} to ${newNumberOfGrids}. Please add more capital or reduce the trade size to maintain at least ${originalGrids} steps.`;
      }
    }
  }

  // --- XENO_ARC STRATEGY ---
  else if (strategy === "xeno arc") {
    if(!isEdit){
      if (!s.capital || s.capital < formattedMinimum){
      errors.capital = `Minimum capital is ${formattedMinimum} ${baseCurrency}.`;
      }
      if (!s.amount || s.amount < formattedMinimum)
        errors.amount = `Minimum trade size is ${formattedMinimum} ${baseCurrency}.`;
      if (s.capital > 0 && s.amount > 0) {
        const maxGrids = Math.floor(s.capital / s.amount);
  
        if (selectedSetting !== "system" && !isEdit) {
          if (Number(s.number_of_grids) > maxGrids)
            errors.number_of_grids = `Max steps is ${maxGrids} for the selected capital.`;
          else if (Number(s.number_of_grids) < 1)
            errors.number_of_grids = "Number of steps must be at least 1.";
        }
  
        if (s.capital < s.amount){
          errors.capital = "Capital must be greater than trade size.";
        }
      }
    }


    // ADD: Edit mode — validate total trade size vs total capital
    if (isEdit && botDetail) {
      const originalCapital = Number(botDetail?.setting?.capital) || 0;
      const originalAmount = Number(botDetail?.setting?.amount) || 0;
      const originalGrids = Number(botDetail?.setting?.number_of_grids) || 0;

      const totalCapital = originalCapital + additionalCapital;
      const newTradeSize = Number(s.amount);
      const newNumberOfGrids = Math.floor(totalCapital / newTradeSize);

      if (newTradeSize < originalAmount) {
        errors.amount = `Trade size cannot be lower than the original trade size (${originalAmount} ${baseCurrency}).`;
      }

      if (newTradeSize > totalCapital) {
        errors.capital = `Trade size (${newTradeSize} ${baseCurrency}) exceeds total capital (${totalCapital} ${baseCurrency}). Please add more capital to proceed.`;
      }

      if (newNumberOfGrids < originalGrids) {
        errors.capital = `Current settings would reduce grid steps from ${originalGrids} to ${newNumberOfGrids}. Please add more capital or reduce the trade size to maintain at least ${originalGrids} steps.`;
      }
    }
  }

  // --- DCA STRATEGY ---
  else if (strategy === "dca") {
    if (!s.capital || s.capital < formattedMinimum){
      if(!isEdit){
        errors.capital = `Minimum capital is ${formattedMinimum} ${baseCurrency}.`;
      }
    }

    if (!s.amount || s.amount < formattedMinimum)
      errors.amount = `Minimum trade size is ${formattedMinimum} ${baseCurrency}.`;

    if (s.capital > 0 && s.amount > 0) {
      const maxOrders = Math.floor(s.capital / s.amount);
      const mxOrders = Number(s.max_order_count);

      if (mxOrders > maxOrders && !isEdit) {
        errors.max_order_count = `Max order is ${maxOrders} for the selected capital.`;
      } else if (mxOrders < 1) {
        errors.max_order_count = "Max order must be at least 1.";
      }
    }
  }

  return errors;
};

// for backtest
export const validateGridConfig = (type, data) => {
  const errs = {};

  if (type === "grid") {
    const capital = Number(data["grid-capital"]);
    const amount = Number(data["grid-amount"]);
    const grids = Number(data["grid-number_of_grids"]);

    if (amount * grids > capital) {
      errs["grid-number_of_grids"] =
        "Number of grids is too large for the given capital and amount.";
    }
  }

  if (type === "xeno arc") {
    const capital = Number(data["xeno-capital"]);
    const amount = Number(data["xeno-amount"]);
    const grids = Number(data["xeno-number_of_grids"]);

    if (amount * grids > capital) {
      errs["xeno-number_of_grids"] =
        "Number of grids exceeds capital based on trade amount.";
    }
  }

  return errs;
};
